<template>
  <button
    type="button"
    class="theme-toggle"
    :class="{ 'theme-toggle--compact': compact }"
    :aria-label="isDark ? $t('theme.switchToLight') : $t('theme.switchToDark')"
    :title="isDark ? $t('theme.lightMode') : $t('theme.darkMode')"
    @click="themeStore.toggle()"
  >
    <KohIcon :name="isDark ? 'sun' : 'moon'" :size="compact ? 'sm' : 'md'" />
    <span v-if="!compact" class="theme-toggle__label">{{ isDark ? $t('theme.light') : $t('theme.dark') }}</span>
  </button>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useThemeStore } from '../stores/theme'
import KohIcon from './KohIcon.vue'

defineProps({
  compact: { type: Boolean, default: false },
})

const themeStore = useThemeStore()
const { isDark } = storeToRefs(themeStore)
</script>

<style scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 1rem;
  border-radius: var(--koh-radius-pill, 999px);
  border: 1px solid var(--koh-border-subtle, rgba(0, 0, 0, 0.08));
  background: var(--koh-bg-card, #fff);
  color: var(--koh-text-primary, #333);
  font-family: var(--koh-font-ui);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s, border-color 0.2s;
  line-height: 1;
}

.theme-toggle:hover {
  background: var(--koh-bg-card-muted, #f8f9fa);
  transform: translateY(-1px);
}

.theme-toggle--compact {
  padding: 0.55rem;
  min-width: 2.5rem;
  min-height: 2.5rem;
  justify-content: center;
}

.theme-toggle__label {
  white-space: nowrap;
}
</style>
